import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { SearchItem, SearchItemType } from '../../SearchItem';
import { ClearButton, LabelDesktop, LabelMobile, QueriesContainer, SearchSubHeader } from './RecentSearchBody.styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function RecentSearchBody(_ref) {
  let {
    hits,
    onClearAll,
    onKeyDown,
    autocomplete,
    onAppend: _onAppend,
    clearRecentSearchRef
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(SearchSubHeader, {
      children: [/*#__PURE__*/_jsx(LabelDesktop, {
        children: "Recent searches"
      }), /*#__PURE__*/_jsx(LabelMobile, {
        children: "Recent Searches"
      }), /*#__PURE__*/_jsx(ClearButton, {
        ref: clearRecentSearchRef,
        type: "button",
        role: "button",
        onClick: onClearAll,
        onKeyDown: onKeyDown,
        "aria-label": "Clear search history"
      })]
    }), /*#__PURE__*/_jsx(QueriesContainer, {
      id: "search-field-listbox",
      role: "listbox",
      "aria-label": "Recent searches",
      children: hits.map(collection => {
        const {
          source,
          items
        } = collection;
        return items.length > 0 && items.map(item => /*#__PURE__*/_jsx(SearchItem, _objectSpread({
          type: SearchItemType.RECENT,
          onAppend: () => _onAppend(item),
          item: item
        }, autocomplete.getItemProps({
          item,
          source
        })), item.objectID));
      })
    })]
  });
}